<div class="font-modal-overlay" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="font-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="font-modal-header">
      <button class="font-modal-back" (click)="onClose()">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M11 3L5 9L11 15" stroke="#15172E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h3 class="font-modal-title">{{ title }}</h3>
      <div class="font-modal-spacer"></div>
    </div>

    <!-- Font List -->
    <div class="font-list">
      <div class="font-card" 
           *ngFor="let font of fonts; trackBy: trackByIndex"
           [class.selected]="tempSelectedFont === font.value"
           (click)="onFontSelect(font)">
        <div class="font-preview-text" [style.font-family]="font.value">
          <div class="preview-line-1">The five boxing wizards</div>
          <div class="preview-line-2">Jump quickly together</div>
        </div>
        <div class="font-divider"></div>
        <div class="font-name">{{ font.name }}</div>
      </div>
    </div>

    <!-- Apply Button -->
    <div class="font-modal-footer">
      <button class="apply-btn" (click)="onApply()">
        Apply
      </button>
    </div>
  </div>
</div>

